// @ts-check
import React from "react";

import ShowIf from "../../ShowIf";
import styles from "./Photos.module.scss";
import i18n from "../../../constants/i18n";
import { closestCenter, DndContext } from "@dnd-kit/core";
import { rectSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import { SortablePhoto } from "./SortablePhoto";
import { PlaceholderView } from "../../TimelinePhoto/PlaceholderView";
import { TimelinePhotoWrapper } from "../../TimelinePhoto/TimelinePhotoWrapper";
import { restrictToFirstScrollableAncestor } from "@dnd-kit/modifiers";

const PhotosView = ({
    onHandleReorder,
    photos,
    ceremonyId,
    ceremony,
    showPhotoUploadModal,
    showPhotoAdjustmentModal,
    deletePhoto,
    useBlurredPhotoBackground,
    onBlurredBackgroundClick,
    blurredBackgroundEnabledCheck,
    items,
    blockImages,
}) => {
    const handleDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;

        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);

        if (oldIndex !== -1 && newIndex !== -1) {
            onHandleReorder(oldIndex, newIndex);
        }
    };

    return (
        <div className={`${styles.root} tutorial-step-1`}>
            <div className="level">
                <div className="level-left">
                    <div className="level-item">
                        <h2 className={styles.title}>Foto's</h2>
                        <div
                            onClick={() => showPhotoUploadModal()}
                            className="icon-container is-round is-clickable"
                        >
                            <span className="icon is-small">
                                <i className="fas fa-s fa-plus" />
                            </span>
                        </div>
                    </div>
                    <ShowIf condition={blurredBackgroundEnabledCheck}>
                        <div className="level-item">
                            <button
                                className="button is-rounded tutorial-step-5"
                                onClick={() =>
                                    onBlurredBackgroundClick(ceremony)
                                }
                            >
                                <ShowIf condition={useBlurredPhotoBackground}>
                                    {i18n.photos.blackBackground}
                                </ShowIf>
                                <ShowIf condition={!useBlurredPhotoBackground}>
                                    {i18n.photos.blurredBackground}
                                </ShowIf>
                            </button>
                        </div>
                    </ShowIf>
                </div>
            </div>
            <div className={`tile is-ancestor ${styles.tileAncestor}`}>
                <DndContext
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    modifiers={[restrictToFirstScrollableAncestor]}
                >
                    <SortableContext
                        items={items.map((item) => item.id)}
                        strategy={rectSortingStrategy}
                    >
                        <div
                            style={{
                                display: "grid",
                                gridAutoFlow: "column", // fills columns first
                                gridTemplateRows: "repeat(2, 1fr)", // 2 rows high
                                gridGap: "8px",
                            }}
                        >
                            {items.map((photo, index) => (
                                <TimelinePhotoWrapper key={photo.id}>
                                    <SortablePhoto
                                        photo={photo}
                                        positionIndex={index}
                                        ceremonyId={ceremonyId}
                                        showPhotoAdjustmentModal={
                                            showPhotoAdjustmentModal
                                        }
                                        deletePhoto={deletePhoto}
                                        blockImages={blockImages}
                                    />
                                </TimelinePhotoWrapper>
                            ))}
                            {items.length < 24 &&
                                Array.from({ length: 24 - items.length }).map(
                                    (_, index) => {
                                        return (
                                            <TimelinePhotoWrapper key={index}>
                                                <div
                                                    className={styles.spacer}
                                                ></div>
                                                <PlaceholderView
                                                    showPhotoUploadModal={
                                                        showPhotoUploadModal
                                                    }
                                                />
                                            </TimelinePhotoWrapper>
                                        );
                                    }
                                )}
                        </div>
                    </SortableContext>
                </DndContext>
            </div>
        </div>
    );
};

export default PhotosView;
